import { render, staticRenderFns } from "./ProductTypesControl.vue?vue&type=template&id=47aa2f45&"
import script from "./ProductTypesControl.vue?vue&type=script&lang=js&"
export * from "./ProductTypesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports